import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AdminDashboardScreen() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to log out?')) {
      try {
        await supabase.auth.signOut();
        navigate('/');
      } catch (error: any) {
        alert('Failed to log out');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-md sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <button
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-gray-900 font-semibold transition-colors"
            >
              ← Back to Home
            </button>
            <h2 className="text-xl font-bold text-[#B85C38]">Admin Panel</h2>
          </div>
        </div>
      </nav>

      <div className="bg-[#B85C38] py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-white mb-3">Admin Dashboard</h1>
        <p className="text-lg text-white">Manage Harvest House Tobique</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Quick Stats</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <p className="text-4xl font-bold text-[#B85C38] mb-2">-</p>
              <p className="text-gray-600 text-sm">Total Devotionals</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <p className="text-4xl font-bold text-[#B85C38] mb-2">-</p>
              <p className="text-gray-600 text-sm">Upcoming Events</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <p className="text-4xl font-bold text-[#B85C38] mb-2">-</p>
              <p className="text-gray-600 text-sm">Donations</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md text-center">
              <p className="text-4xl font-bold text-[#B85C38] mb-2">-</p>
              <p className="text-gray-600 text-sm">Bookings</p>
            </div>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Management</h2>
          <div className="space-y-4">
            <button
              onClick={() => navigate('/admin-messages')}
              className="w-full bg-white py-5 rounded-xl shadow-md hover:shadow-lg transition-shadow text-left px-6"
            >
              <p className="text-xl font-semibold text-gray-900">View Messages & Requests</p>
              <p className="text-sm text-gray-600 mt-1">Manage contact form messages and case manager requests</p>
            </button>
            <button
              onClick={() => navigate('/notice-board')}
              className="w-full bg-white py-5 rounded-xl shadow-md hover:shadow-lg transition-shadow text-left px-6"
            >
              <p className="text-xl font-semibold text-gray-900">Manage Notice Board</p>
              <p className="text-sm text-gray-600 mt-1">Post and manage community notices</p>
            </button>
            <button className="w-full bg-white py-5 rounded-xl shadow-md hover:shadow-lg transition-shadow text-left px-6">
              <p className="text-xl font-semibold text-gray-900">Manage Devotionals</p>
            </button>
            <button className="w-full bg-white py-5 rounded-xl shadow-md hover:shadow-lg transition-shadow text-left px-6">
              <p className="text-xl font-semibold text-gray-900">Manage Events</p>
            </button>
            <button className="w-full bg-white py-5 rounded-xl shadow-md hover:shadow-lg transition-shadow text-left px-6">
              <p className="text-xl font-semibold text-gray-900">View Donations</p>
            </button>
          </div>
        </div>

        <div className="mb-8">
          <button
            onClick={handleLogout}
            className="w-full bg-red-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors"
          >
            Logout
          </button>
        </div>

        <div className="bg-[#E8DDD0] rounded-xl p-8 border-l-4 border-[#B85C38]">
          <p className="text-gray-700 leading-relaxed text-center">
            Full admin functionality is coming soon to the mobile app. For now, please use the web dashboard for detailed management.
          </p>
        </div>
      </div>
    </div>
  );
}
